import styled from "styled-components";
import { WrapperContainer } from "../../../../../components";

export const LanguageNameWrapper = styled(WrapperContainer)`
  cursor: pointer;
  width: 100%;

  input {
    cursor: pointer;

    &:disabled {
      cursor: default;
    }
  }
`;
